import { z } from 'zod';
import { defineCollection, type RecordOf } from '../collection.ts';
import { id, isoDate, longText, shortText } from '../fields.ts';

/** A dated journal entry with optional photos. Not a feed: no likes, no ranking. */
export const memories = defineCollection({
  name: 'memories',
  module: 'memories',
  label: { one: 'memory', other: 'memories' },
  schema: z
    .object({
      date: isoDate,
      title: shortText(200).default(''),
      body: longText(20_000).default(''),
      fileIds: z.array(id).max(30).default([]),
    })
    .refine((m) => m.title.trim() !== '' || m.body.trim() !== '' || m.fileIds.length > 0, {
      message: 'Add a title, some words or a photo',
    }),
  defaultAudience: 'family',
  childAccess: 'contribute',
  editPolicy: 'author',
  immutableFields: [],
  manualMergeFields: ['body'],
});

export type Memory = RecordOf<typeof memories>;
